import React from "react";

const RYoutubePlayer = () => {
  return null; // or a link / placeholder
};

export default RYoutubePlayer;
